import { useEffect, useState } from "react";
import PaymentMethod from "../../components/paymentMethods";
import OrderService from "../../rest/orderService";
import { MdCheckCircleOutline, MdChevronLeft, MdChevronRight, MdOutlineCancel } from 'react-icons/md';
import { BiCheckCircle } from 'react-icons/bi';
import Lottie from 'react-lottie';
import completedAnimation from '../../resources/completed_animation2.json'
import canceledAnimation from '../../resources/canceled_animation.json'
import loadingAnimation from '../../resources/loading_animation.json'
import { useNavigate } from "react-router";
import ProductGridSale from "../../components/productGridSale";
import { TiTick } from "react-icons/ti";
import CustomerService from "../../rest/customerService";
import MenuService from "../../rest/menuService";
import TopNavBar from "../../components/reusables/topNavBar";
import ProductService from "../../rest/productService";
import { ajustedDate, getToday } from "../../utils/DateUtils";
import FinancialService from "../../rest/financialService";
import ComboService from "../../rest/comboService";
import ClientService from "../../rest/clientService";
import ModalPortal from "../../components/lib/modalPortal";
import OrderSummary from "../../components/reusables/orderSummary";
import CreditCardPaymentModal from "../../components/CreditCardPaymentModal";
import PaymentService from "../../rest/paymentsService";
import NotificationsService from "../../rest/notificationService";

const NewOrderCustomer = () => {
    const [loading, setLoading] = useState(false);
    const steps = ['Pedido', 'Pagamento', 'Resumo'];
    const [customer, setCustomer] = useState('');
    const [totalSpentToday, setTotalSpentToday] = useState(0.0);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [list, setList] = useState([]);
    const [showAnimation, setShowAnimation] = useState(false);
    const [animation, setAnimation] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [itemCount, setItemCount] = useState(0);
    const [showInsuficientCreditsMessage, setshowInsuficientCreditsMessage] = useState(false);
    const [showModalDailyLimit, setShowModalDailyLimit] = useState(false);
    const [showCardModal, setShowCardModal] = useState(false);
    const [pixPayment, setPixPayment] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [clientInfo, setClientInfo] = useState();
    const [asaasEnabled, setAsaasEnabled] = useState(false);

    const [order, setOrder] = useState({
        order_id: '',
        cashier_id: '',
        client_id: '',
        items_list: '',
        total: '',
        status: '',
        sale_point: '',
        client_code: '',
        transactions: [],
    });

    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        const info = JSON.parse(sessionStorage.getItem('clientInfo'));
        setClientInfo(info);
        const searchInput = getToday();

        const checkIfOpen = async () => {
            try {
                const data = await FinancialService.checkIfOpen(searchInput);
                setIsOpened(data);
            } catch (error) {
                console.error(error);
                setIsOpened(false);
            }
        };

        const getIntegration = async () => {
            const clientCode = sessionStorage.getItem('clientCode');
            try {
                const status = await PaymentService.getIntegrationStatus(clientCode);
                setAsaasEnabled(status?.asaasEnabled ?? false);
            } catch { setAsaasEnabled(false); }
        };

        checkIfOpen();
        getIntegration();
    }, [isOpened]);

    useEffect(() => {
        let count = 0;
        selectedProducts.forEach((p) => {
            count += p.quantity;
        });
        setItemCount(count);
    }, [selectedProducts]);

    const login = sessionStorage.getItem("login");

    const getStudent = async () => {
        const student = await CustomerService.getSpecificStudent(login);
        const filteredItem = {
            email: student.email,
            name: student.name,
            grade: student.grade,
            credit: student.credit,
            id_student: student.id_student,
            login: student.login,
            phone_number: student.phone_number,
            emergency_value: student.emergency_value,
            spend_limit: student.spend_limit,
            client_code: student.client_code,
            username: student.username
        };

        setCustomer(filteredItem);
    }

    useEffect(() => {
        try {
            getStudent();

            OrderService.getClientTodayTotalSpent(login)
                .then(setTotalSpentToday)
                .catch(console.error);
        } catch (error) {
            console.error(error);
        }
    }, []);

    const handleStep1Value = (value) => {
        setSelectedProducts(value)
    };

    const handleStep2Value = (transactions) => {
        setOrder(prevOrder => ({
            ...prevOrder,
            transactions: transactions
        }));
    };

    const calculateTotalAmount = (products) => {
        const amount = products.reduce((total, product) => {
            return total + product.price * product.quantity;
        }, 0);
        setTotalAmount(amount.toFixed(2));
    };

    const calculateTotalReceived = () => {
        return order.transactions.reduce((acc, transaction) => {
            const value = parseFloat(transaction.value) || 0;
            return acc + value;
        }, 0);
    };


    const calculateChange = () => {
        const totalReceived = calculateTotalReceived();
        return totalReceived - totalAmount;
    };

    const [change, setChange] = useState(calculateChange());
    useEffect(() => {
        setChange(calculateChange());
    }, [order.transactions, totalAmount]);

    const generateItemList = (products) => {
        return products.map(product => `${product.id} x${product.name} x${product.quantity} x${product.type} x${product.price}`).join(', ');
    };
    
    useEffect(() => {
        calculateTotalAmount(selectedProducts);
        setOrder(prevOrder => ({
            ...prevOrder,
            order_id: prevOrder.order_id === '' ? Math.floor(Math.random() * 999999999) : prevOrder.order_id,
            cashier_id: 'self',
            client_id: `${customer.login} / ${customer.name}`,
            purchase_date: ajustedDate(),
            items_list: generateItemList(selectedProducts),
            total: totalAmount,
            status: order.transactions.length === 1 && order.transactions[0] === 'CREDITO FOODZ' ? 'COMPLETED' : 'PROCESSINGPAYMENT',
            sale_point: 'WEBAPP',
            client_code: sessionStorage.getItem('clientCode'),
            last_update: ajustedDate(),
        }));
    }, [customer, totalAmount, selectedProducts]);

    const checkBalanceForOrder = () => {
        const totalAmountWithEmergencyValue = totalAmount - customer.emergency_value;

        if (customer.credit >= totalAmount) {
            return true;
        } else if (customer.credit === 0 && totalAmount <= customer.emergency_value) {
            return true;
        } else if (customer.credit === 0 && totalAmount > customer.emergency_value) {
            return false;
        } else if (customer.credit < 0 && totalAmount <= (customer.credit + customer.emergency_value)) {
            return true;
        } else if (customer.credit < 0 && totalAmount > (customer.credit + customer.emergency_value)) {
            return false;
        } else if (customer.credit > 0 && totalAmountWithEmergencyValue <= customer.credit) {
            return true;
        } else return customer.credit > 0 && totalAmountWithEmergencyValue <= (customer.credit + customer.emergency_value);
    };

    const updateCredits = () => {
        const newCredit = customer.credit - totalAmount;
        return Math.max(-customer.emergency_value, newCredit).toFixed(2);
    }

    async function updateClientData() {
        try {
            await CustomerService.updateStudentCredit(
                customer.login,
                {
                    "login": customer.login,
                    "credit": customer.credit,
                    "client_code": customer.client_code
                },
                order.transactions[0]);
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    async function updateProductData() {
        try {
            for (const s of selectedProducts) {
                if (s.type === "product") {
                    await ProductService.updateProductQuantity(s.id, "REMOVE", {
                        "product_id": s.id,
                        "quantity": s.quantity,
                        "client_code": s.client_code
                    });
                } else if (s.type === "recipe") {
                    await MenuService.updateRecipeQuantity(s.id, "REMOVE", {
                        "recipe_id": s.id,
                        "quantity": s.quantity,
                        "client_code": s.client_code
                    });
                } else if (s.type === "combo") {
                    await ComboService.updateComboQuantity(s.id, "REMOVE", {
                        "combo_id": s.id,
                        "quantity": s.quantity,
                        "client_code": s.client_code
                    });
                }
            }

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    async function notifyPurchase(skipNavigate = false) {
        const preferences = await ClientService.getClientAdminPreferences();
        const send = preferences?.enable_send_notifications === true;

        if (send) {
            NotificationsService.sendEmailNotificationForOrder(clientInfo, customer, order, 'Pedido feito pelo acesso do Cliente', change, selectedProducts)
                .then(() => {
                    setAnimation(completedAnimation);
                    setLoading(false);
                    setShowAnimation(true);
                    if (!skipNavigate) setTimeout(() => navigate(`/clientes/detalhesCliente/${customer.login}`), 1000);
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response && error.response.status === 400) {
                        setAnimation(completedAnimation);
                        setShowAnimation(true);
                        if (!skipNavigate) setTimeout(() => navigate(`/clientes/detalhesCliente/${customer.login}`), 1000);
                    }
                });
        } else {
            setAnimation(completedAnimation);
            setShowAnimation(true);
            if (!skipNavigate) setTimeout(() => navigate(`/clientes/detalhesCliente/${customer.login}`), 1000);
        }
    }

    const handleSubmit = async () => {
        const total = parseFloat(order.total)
        const totalToday = parseFloat(totalSpentToday)
        const isValidPixPayment = order.transactions.some(transaction => transaction.paymentMethod === 'PIX');

        if (total + totalToday > customer.spend_limit) {
            handleDailyLimit();
        } else {
            if (order.transactions.length === 1 && order.transactions[0].paymentMethod === 'Crédito Foodz') {
                if (customer.isPayingCustomer === true) {
                    if (checkBalanceForOrder() === true) {
                        customer.credit = updateCredits();
                        OrderService.registerOrder({ order })
                            .then(() => {
                                setLoading(true);
                                setAnimation(loadingAnimation);
                                setShowAnimation(true);
                                updateClientData()
                                    .catch((error) => {
                                        console.error(error);
                                    }).then
                                    (
                                        updateProductData()
                                            .then((updateSuccess) => {
                                                if (updateSuccess) {
                                                    notifyPurchase();
                                                }
                                            })
                                            .catch((error) => {
                                                console.error(error);
                                            }));
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                    } else {
                        setshowInsuficientCreditsMessage(!showInsuficientCreditsMessage);
                    }
                } else {
                    OrderService.registerOrder({ order })
                        .then(() => {
                            setLoading(true);
                            setAnimation(loadingAnimation);
                            setShowAnimation(true);
                            updateProductData()
                                .then((updateSuccess) => {
                                    if (updateSuccess) {
                                        notifyPurchase();
                                    }
                                })
                                .catch((error) => {
                                    console.error(error);
                                })
                        });
                }
            } else if (isValidPixPayment) {
                try {
                    const response = await OrderService.registerOrder({ order });
                    setLoading(true);
                    setAnimation(loadingAnimation);
                    setShowAnimation(true);
                    updateProductData().then(success => {
                        if (success) notifyPurchase(true);
                    }).catch(console.error);
                    if (response.data?.payment?.qrCodeEncodedImage) {
                        setPixPayment(response.data.payment);
                    }
                } catch (error) {
                    console.error("Erro ao registrar pedido PIX:", error);
                }
            } else {
                const hasCreditCardTx = order.transactions.some(tx => {
                    const base = (tx.paymentMethod || '').split('/')[0];
                    return base === 'CREDITO' || base === 'DEBITO';
                });

                if (hasCreditCardTx) {
                    setShowCardModal(true);
                    return;
                }

                OrderService.registerOrder({ order })
                    .then(() => {
                        setLoading(true);
                        setAnimation(loadingAnimation);
                        setShowAnimation(true);
                        notifyPurchase();
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    };

    const handleCardPay = (cardPaymentData) => {
        setShowCardModal(false);
        const payload = {
            order: { ...order, status: 'PROCESSINGPAYMENT' },
            creditCardToken: cardPaymentData.creditCardToken || null,
            creditCardData: cardPaymentData.creditCardData || null,
        };
        OrderService.registerOrder(payload)
            .then(() => {
                setLoading(true);
                setAnimation(loadingAnimation);
                setShowAnimation(true);
                notifyPurchase();
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (showAnimation) {
            setTimeout(() => {
                setShowAnimation(false);
            }, 5000);
        }
    }, [showAnimation]);

    const handleDailyLimit = () => {
        setShowModalDailyLimit(!showModalDailyLimit)
    }

    const handleCancelClick = () => {
        setShowModalDailyLimit(!showModalDailyLimit)
    }

    const handleChange = () => {
        setshowInsuficientCreditsMessage(!showInsuficientCreditsMessage);
    }

    const handleCancel = () => {
        OrderService.deleteCanceledOrder(order.order_id)
            .then(() => {
                setAnimation(canceledAnimation);
                setTimeout(() => {
                    setShowAnimation(true);
                    navigate(`/clientes/detalhesCliente/${customer.login}`);
                }, 1000);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handlePrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleNext = () => {
        const isStepValid = validateStep(currentStep);
        if (isStepValid) {
            if (currentStep <= steps.length) {
                setCurrentStep(currentStep + 1);
            }
        }
    };

    const validateStep = (step) => {
        switch (step) {
            case 1:
                return selectedProducts.length !== 0;
            case 2:
                return order.transactions.length !== 0;
            default:
                return true;
        }
    };

    const renderStepComponent = () => {
        switch (currentStep) {
            case 1:
                return <ProductGridSale onValueChange={handleStep1Value}
                    selectedItems={selectedProducts}
                    list={list}
                    setList={setList}
                    isCustomer={true} />;
            case 2:
                return <PaymentMethod
                    totalAmount={totalAmount}
                    onTransactionChange={handleStep2Value}
                    showCreditCard={true}
                    asaasEnabled={asaasEnabled}
                />;
            default:
                return <OrderSummary order={order} customer={customer} selectedProducts={selectedProducts} itemCount={itemCount} totalAmount={totalAmount} />


        }

    };

    const [isLgScreen, setIsLgScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => setIsLgScreen(window.innerWidth >= 1024);
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);



    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Novo Pedido"} subtitle={""} />
            {showAnimation && (
                <div
                    className="flex flex-col items-center justify-center fixed inset-0 z-50 bg-white">
                    <div className="flex flex-col items-center justify-center h-full w-full">
                        <Lottie
                            options={{
                                animationData: animation,
                            }}

                            style={{
                                height: '40%',
                                width: '40%'
                            }}
                        />
                        {loading === true ? <></> :
                            <p className={`text-5xl font-bold text-center 
                                ${animation === completedAnimation ? 'text-green_animation' : 'text-red_animation'}`}>{animation === completedAnimation ? 'Pedido Finalizado!' :
                                    'Pedido Cancelado!'}</p>
                        }
                    </div>
                </div>
            )}
            <div className='mx-2 lg:mx-10 my-6 font-poppins text-custom_lighter_gray_font'>
                <div className="flex w-full h-full rounded-lg border-2 my-6 border-slate-200">
                    {isOpened ?
                        <>
                            <div className='flex-col w-full'>
                                <div className="w-full flex items-center justify-between my-6 px-6">
                                    <button
                                        onClick={handlePrevious}
                                        disabled={currentStep <= 1 || loading}
                                        className="bg-custom_blue hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-1 px-3  rounded"
                                    >
                                        <span className="hidden xl:block">Voltar</span>
                                        <MdChevronLeft className="block xl:hidden" size={16} />
                                    </button>

                                    {isLgScreen && (
                                        <div className="flex justify-center items-center">
                                            {steps.map((step, i) => (
                                                <div
                                                    key={i}
                                                    className={`flex-col items-center text-center font-semibold ${i + 1 < currentStep ? "text-custom_green" : ""}`}
                                                >
                                                    <div>
                                                        {i + 1 < currentStep ? (
                                                            <>
                                                                <TiTick className="hidden xl:block" size={20} />
                                                                <TiTick className="block xl:hidden" size={12} />
                                                            </>
                                                        ) : (
                                                            i + 1
                                                        )}
                                                    </div>
                                                    <p className="text-xs px-1">{step}</p>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {!isLgScreen && (
                                        <div className="text-base px-1">
                                            <p>{steps[currentStep - 1]}</p>
                                        </div>
                                    )}

                                    {currentStep < steps.length ? (
                                        <button
                                            onClick={handleNext}
                                            disabled={!validateStep(currentStep) || loading}
                                            className="bg-custom_blue hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-1 px-3 rounded"
                                        >
                                            <span className="hidden xl:block">Próximo</span>
                                            <MdChevronRight className="block xl:hidden" size={16} />
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="bg-custom_green hover:bg-green-600 disabled:opacity-50 text-white font-semibold py-1 px-3 rounded"
                                            onClick={() => {
                                                handleNext();
                                                handleSubmit();
                                            }}
                                            disabled={!validateStep(currentStep) || loading || change < 0}
                                        >
                                            <span className="hidden xl:block">Finalizar</span>
                                            <MdCheckCircleOutline className="block xl:hidden" size={16} />
                                        </button>
                                    )}
                                </div>
                                <div className='mx-6'>
                                    {renderStepComponent()}
                                </div>
                            </div>

                            {showInsuficientCreditsMessage && (
                                <ModalPortal>
                                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                        <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                            <p className="p-4 text-2xl">Não é possível finalizar a compra por falta de créditos.
                                                Escolha
                                                outra forma de pagamento ou recarregue a quantidade de créditos Foodz!</p>
                                            <p className="p-4 text-lg"> (Obs.: Ao cancelar um pedido, nenhum registro da venda
                                                ficará
                                                salvo.)</p>
                                            <div className="flex align-center justify-center p-6">
                                                <button
                                                    className='flex align-center justify-center bg-custom_blue w-full h-full text-white font-medium p-2 m-2 rounded-lg'
                                                    onClick={handleChange}>
                                                    <BiCheckCircle className="text-white scale-150 mx-2" />
                                                    <p className=" text-white font-medium leading-tight">Mudar Pagamento</p>
                                                </button>
                                                <button
                                                    className='flex align-center justify-center bg-custom_red w-full h-full text-white font-medium p-2 m-2 rounded-lg'
                                                    onClick={handleCancel}>
                                                    <MdOutlineCancel className="text-white scale-150 mx-2" />
                                                    <p className="text-white font-medium leading-tight"> Cancelar Pedido</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ModalPortal>
                            )}

                            {showModalDailyLimit && (
                                <ModalPortal>
                                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                        <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                            <p className="p-4 text-2xl">Não é possível finalizar a compra pois o cliente já
                                                atingiu o
                                                limite de gastos diários estabelecido pelo seu(s) responsável(is).</p>
                                            <div className="flex items-center justify-center p-6">
                                                <button
                                                    className="bg-custom_green text-white font-medium p-3 ml-2 rounded-lg"
                                                    onClick={handleCancelClick}
                                                >
                                                    <p className="text-white font-medium"> OK </p>
                                                    <BiCheckCircle className="scale-150" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ModalPortal>
                            )}
                        {showCardModal && (
                            <CreditCardPaymentModal
                                customer={customer}
                                clientCode={sessionStorage.getItem('clientCode')}
                                totalAmount={totalAmount}
                                onPay={handleCardPay}
                                onCancel={() => setShowCardModal(false)}
                            />
                        )}

                        {pixPayment && (
                            <ModalPortal>
                                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6">
                                    <div className="rounded-lg bg-white text-center w-full max-w-sm z-50 p-8 shadow-lg">
                                        <h2 className="text-xl font-semibold mb-4">Pagamento PIX</h2>
                                        <img
                                            src={`data:image/png;base64,${pixPayment.qrCodeEncodedImage}`}
                                            alt="QR Code PIX"
                                            className="w-64 h-64 mx-auto border-2 border-gray-300"
                                        />
                                        <p className="mt-4 text-sm text-gray-600">Ou copie o código abaixo:</p>
                                        <input
                                            type="text"
                                            readOnly
                                            value={pixPayment.qrCodePayload || ''}
                                            className="w-full mt-2 p-2 text-xs border rounded text-center"
                                        />
                                        <button
                                            className="mt-2 text-sm text-custom_blue underline"
                                            onClick={() => navigator.clipboard.writeText(pixPayment.qrCodePayload || '')}
                                        >
                                            Copiar código
                                        </button>
                                        <div className="mt-6">
                                            <button
                                                className="bg-custom_green text-white font-medium py-2 px-6 rounded-lg"
                                                onClick={() => { setPixPayment(null); navigate(`/clientes/detalhesCliente/${customer.login}`); }}
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ModalPortal>
                        )}
                        </>
                        :
                        <>
                            <div className='flex-col w-full'>
                                <div className="w-full flex items-center justify-between my-6 px-6">
                                    <button
                                        onClick={handlePrevious}
                                        disabled={currentStep <= 1 || loading}
                                        className="bg-custom_blue hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-1 px-3  rounded"
                                    >
                                        <span className="hidden xl:block">Voltar</span>
                                        <MdChevronLeft className="block xl:hidden" size={16} />
                                    </button>

                                    {isLgScreen && (
                                        <div className="flex justify-center items-center">
                                            {steps.map((step, i) => (
                                                <div
                                                    key={i}
                                                    className={`flex-col items-center text-center font-semibold ${i + 1 < currentStep ? "text-custom_green" : ""}`}
                                                >
                                                    <div>
                                                        {i + 1 < currentStep ? (
                                                            <>
                                                                <TiTick className="hidden xl:block" size={20} />
                                                                <TiTick className="block xl:hidden" size={12} />
                                                            </>
                                                        ) : (
                                                            i + 1
                                                        )}
                                                    </div>
                                                    <p className="text-xs px-1">{step}</p>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {!isLgScreen && (
                                        <div className="text-base px-1">
                                            <p>{steps[currentStep - 1]}</p>
                                        </div>
                                    )}

                                    {currentStep < steps.length ? (
                                        <button
                                            onClick={handleNext}
                                            disabled={!validateStep(currentStep) || loading}
                                            className="bg-custom_blue hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-1 px-3 rounded"
                                        >
                                            <span className="hidden xl:block">Próximo</span>
                                            <MdChevronRight className="block xl:hidden" size={16} />
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="bg-custom_green hover:bg-green-600 disabled:opacity-50 text-white font-semibold py-1 px-3 rounded"
                                            onClick={() => {
                                                handleNext();
                                                handleSubmit();
                                            }}
                                            disabled={!validateStep(currentStep) || loading || change < 0}
                                        >
                                            <span className="hidden xl:block">Finalizar</span>
                                            <MdCheckCircleOutline className="block xl:hidden" size={16} />
                                        </button>
                                    )}
                                </div>
                                <div className='mx-6'>
                                    {renderStepComponent()}
                                </div>
                            </div>

                            {showInsuficientCreditsMessage && (
                                <ModalPortal>
                                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                        <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                            <p className="p-4 text-2xl">Não é possível finalizar a compra por falta de créditos.
                                                Escolha
                                                outra forma de pagamento ou recarregue a quantidade de créditos Foodz!</p>
                                            <p className="p-4 text-lg"> (Obs.: Ao cancelar um pedido, nenhum registro da venda
                                                ficará
                                                salvo.)</p>
                                            <div className="flex align-center justify-center p-6">
                                                <button
                                                    className='flex align-center justify-center bg-custom_blue w-full h-full text-white font-medium p-2 m-2 rounded-lg'
                                                    onClick={handleChange}>
                                                    <BiCheckCircle className="text-white scale-150 mx-2" />
                                                    <p className=" text-white font-medium leading-tight">Mudar Pagamento</p>
                                                </button>
                                                <button
                                                    className='flex align-center justify-center bg-custom_red w-full h-full text-white font-medium p-2 m-2 rounded-lg'
                                                    onClick={handleCancel}>
                                                    <MdOutlineCancel className="text-white scale-150 mx-2" />
                                                    <p className="text-white font-medium leading-tight"> Cancelar Pedido</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ModalPortal>
                            )}

                            {showModalDailyLimit && (
                                <ModalPortal>
                                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-10" >
                                        <div className="rounded-lg bg-white text-center h-1/2 w-3/4 z-50 p-12 shadow-lg">
                                            <p className="p-4 text-2xl">Não é possível finalizar a compra pois o cliente já
                                                atingiu o
                                                limite de gastos diários estabelecido pelo seu(s) responsável(is).</p>
                                            <div className="flex items-center justify-center p-6">
                                                <button
                                                    className="bg-custom_green text-white font-medium p-3 ml-2 rounded-lg"
                                                    onClick={handleCancelClick}
                                                >
                                                    <p className="text-white font-medium"> OK </p>
                                                    <BiCheckCircle className="scale-150" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ModalPortal>
                            )}
                        </>
                    }
                </div>
            </div>
        </div >
    )
}

export default NewOrderCustomer